import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Addcoapplicant(state = initialState, action) {
  
  //
  switch (action.type) {
    case userConstants.ADDCOAPPLICANT_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.ADDCOAPPLICANT_SUCCESS:
      const {res} = action
      return {
        res,
        isLoading : false
      };
    case userConstants.ADDCOAPPLICANT_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}